import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/portaliCamere';
import { selectors, DEFAULT_STATE } from '../reducers/portaliCamere';
import api from '../apis/portaliCamere';

const sagas = helper.createSagas(
    'portaliCamere',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Camere Portali'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
